import { render, staticRenderFns } from "./LectureDetails.vue?vue&type=template&id=73f304b0&"
import script from "./LectureDetails.vue?vue&type=script&lang=js&"
export * from "./LectureDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports